import { jsx } from "react/jsx-runtime";
import { HotelProductSummaryView } from "./HotelProductSummaryView/index.js";
function ProductSummaryView(props) {
    return /*#__PURE__*/ jsx(HotelProductSummaryView, {
        ...props
    });
}
export { ProductSummaryView };
